import { useCallback, useEffect, useState } from "react";
import { deviceTimeZone, normalizeTimeZone } from "../components/Admin/Scheduling/timeZones";

const CHANGE_EVENT = "scheduling-timezone-change";

export function useSchedulingTimeZone(user) {
  const userId = user?.sub || user?.username || user?.["custom:practitioner_id"];
  const key = `scheduling-display-timezone:${userId || "session"}`;
  const read = useCallback(() => {
    try {
      const saved = (userId ? localStorage : sessionStorage).getItem(key);
      return normalizeTimeZone(saved) || "local";
    } catch {
      return "local";
    }
  }, [key, userId]);
  const [preference, setPreferenceState] = useState(read);
  const [localZone, setLocalZone] = useState(deviceTimeZone);

  useEffect(() => {
    const refresh = () => {
      setPreferenceState(read());
      setLocalZone(deviceTimeZone());
    };
    refresh();
    window.addEventListener(CHANGE_EVENT, refresh);
    window.addEventListener("storage", refresh);
    window.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", refresh);
    return () => {
      window.removeEventListener(CHANGE_EVENT, refresh);
      window.removeEventListener("storage", refresh);
      window.removeEventListener("focus", refresh);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, [read]);

  const setPreference = (value) => {
    const next = normalizeTimeZone(value) || "local";
    try {
      (userId ? localStorage : sessionStorage).setItem(key, next);
      window.dispatchEvent(new Event(CHANGE_EVENT));
    } catch { /* The current view still works when storage is unavailable. */ }
    setPreferenceState(next);
  };

  return { timeZone: preference === "local" ? localZone : preference, deviceTimeZone: localZone, preference, setPreference };
}
